function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M31 61a2.0001 2.0001 0 0 0-2 2V73a2 2 0 0 0 4 0V63A2.0001 2.0001 0 0 0 31 61zM41 61a2.0001 2.0001 0 0 0-2 2V73a2 2 0 0 0 4 0V63A2.0001 2.0001 0 0 0 41 61zM51 61a2.0001 2.0001 0 0 0-2 2V73a2 2 0 0 0 4 0V63A2.0001 2.0001 0 0 0 51 61zM90 60a8 8 0 1 0 8 8A8.01062 8.01062 0 0 0 90 60zm0 12a4 4 0 1 1 4-4A3.99891 3.99891 0 0 1 90 72z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 90,
  cy: 38,
  r: 4
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M120,9a7.99663,7.99663,0,0,0-2,15.74V67H107V59a7.97355,7.97355,0,0,0-2.73-6A7.97365,7.97365,0,0,0,107,47V29a8.01062,8.01062,0,0,0-8-8H95V12h6a3.99891,3.99891,0,0,0,4-4V4a3.99887,3.99887,0,0,0-4-4H27a3.99887,3.99887,0,0,0-4,4V8a3.99891,3.99891,0,0,0,4,4h6v9H29a8.01062,8.01062,0,0,0-8,8V47a7.97365,7.97365,0,0,0,2.73,6A7.97355,7.97355,0,0,0,21,59v8H10V24.74a8,8,0,1,0-4,0V69a2.00591,2.00591,0,0,0,2,2h3.25v41.2a8.00155,8.00155,0,1,0,4,.12994V71H21v6a7.97365,7.97365,0,0,0,2.73,6A7.97355,7.97355,0,0,0,21,89v18a8.01066,8.01066,0,0,0,8,8h4v9a3.99891,3.99891,0,0,0,4,4h4a3.99891,3.99891,0,0,0,4-4v-9H83v9a3.99891,3.99891,0,0,0,4,4h4a3.99891,3.99891,0,0,0,4-4v-9h4a8.01066,8.01066,0,0,0,8-8V89a7.97355,7.97355,0,0,0-2.73-6A7.97365,7.97365,0,0,0,107,77V71h5.75v41.33a7.99856,7.99856,0,1,0,4-.12994V71H120a2.00591,2.00591,0,0,0,2-2V24.74A7.99663,7.99663,0,0,0,120,9ZM4,17a4,4,0,1,1,4,4A3.99887,3.99887,0,0,1,4,17ZM17,120a4,4,0,1,1-4-4A3.99891,3.99891,0,0,1,17,120ZM98,38a8,8,0,1,1-8-8A8.01066,8.01066,0,0,1,98,38ZM45,21V12H83v9Zm8,12V43a2,2,0,0,1-4,0V33a2,2,0,0,1,4,0ZM87,21V12h4v9ZM27,8V4h74V8ZM39,33a2,2,0,0,1,4,0V43a2,2,0,0,1-4,0ZM37,21V12h4v9ZM29,33a2,2,0,0,1,4,0V43a2,2,0,0,1-4,0Zm4,70a2,2,0,0,1-4,0V93a2,2,0,0,1,4,0Zm8,21H37v-9h4Zm2-21a2,2,0,0,1-4,0V93a2,2,0,0,1,4,0Zm10,0a2,2,0,0,1-4,0V93a2,2,0,0,1,4,0Zm38,21H87v-9h4Zm-1-18a8,8,0,1,1,8-8A8.01066,8.01066,0,0,1,90,106Zm13-29a3.99891,3.99891,0,0,1-4,4H29a3.99891,3.99891,0,0,1-4-4V59a3.99887,3.99887,0,0,1,4-4H99a3.99887,3.99887,0,0,1,4,4Zm16,43a4,4,0,1,1-4-4A3.99891,3.99891,0,0,1,119,120Zm1-99a4,4,0,1,1,4-4A3.99891,3.99891,0,0,1,120,21Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 90,
  cy: 98,
  r: 4
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 128 128"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/database.eda4012e.svg";
export { SvgComponent as ReactComponent };